import { RouteObject } from "react-router-dom";
import { RootServicepartnerCreate } from "../pages/admin/base/servicepartners/RootServicepartnerCreate";
import { RootServicepartnerDetail } from "../pages/admin/base/servicepartners/RootServicepartnerDetail";
import { RootServicepartnerList } from "../pages/admin/base/servicepartners/RootServicepartnerList";
import { RootServicepartnerEdit } from "../pages/admin/base/servicepartners/RootServicepartnerEdit";

export const baseServicePartnersRoutes: RouteObject[] = [
  {
    id: "root-service-partners-list",
    index: true,
    element: <RootServicepartnerList />,
  },
  {
    id: "root-service-partners-create",
    path: "create",
    element: <RootServicepartnerCreate />,
  },
  {
    id: "root-service-partners-detail",
    path: ":id",
    element: <RootServicepartnerDetail />,
  },
  {
    id: "root-service-partners-edit",
    path: ":id/edit",
    element: <RootServicepartnerEdit />,
  },
];
